/**
 * The `data-table` LevelKind — non-spatial, no 3Cs. Proves the abstraction isn't
 * platformer-shaped (TDD §0/§5.1).
 */
import type { LevelKind } from '../../types.js';
import { type DataTableLevel, DataTableLevelSchema } from './schema.js';
import { validateDataTable } from './validate.js';

export const dataTableLevelKind: LevelKind<DataTableLevel> = {
  id: 'data-table',
  schema: DataTableLevelSchema,
  consumesThreeCs: false,
  view: 'table',
  derivation: {
    genres: ['grab-bag', 'trivia', 'match-3'],
    mechanicHints: ['loot', 'drop-table', 'inventory', 'library', 'spawn-set'],
  },
  validate: validateDataTable,
};

export { DataTableLevelSchema } from './schema.js';
export type { DataTableLevel, DataTableRow } from './schema.js';
